import React from "react";

export default function SuccessIcon({ color = "#22C55E" }) {
  return (
    <div
      style={{
        textAlign: "center",
        height: "24px",
        width: "24px",
        alignContent: "center",
        alignItems: "center",
        marginLeft: 2,
      }}
    >
      <svg
        width="20"
        height="20"
        viewBox="0 0 24 24"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <circle
          cx="12"
          cy="12"
          r="9"
          stroke={color}
          strokeWidth="1.6"
        />
        <path
          d="M8 12.5L10.5 15L16 9"
          stroke={color}
          strokeWidth="1.6"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </svg>
    </div>
  );
}